<template>
  <div>
    <ul class="orderlist" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="1000"
      :infinite-scroll-immediate="true">

      <li class="listli mt20" v-for="item in orderInfo" v-bind:key="item.orderId">
        <div class="ordertitle font32 c333">
          <span>{{ item.stationName }}</span>
          <span>{{ item.estimatedPickupTime }} 前送还车辆</span>
        </div>

        <div class="ordertitle vehicle">
          <span class="font32 c333">{{ item.numberPlate }}</span>
          <span class="textcolor font32">{{ item.stepDesc }}</span>
        </div>

        <div class="ordercen font28 c999">
          <div class="cenname">订单号：</div>
          <p>{{ item.orderNumber }}</p>
        </div>
        <div class="ordercen font28 c999 mt20">
          <div class="cenname">下单时间：</div>
          <p>{{ item.createTime }}</p>
        </div>
        <div class="ordercen font28 c999 mt20">
          <div class="cenname">钥匙柜：</div>
          <p>{{ item.cabinetName }}</p>
        </div>
        <div class="ordercen font28 c999 mt20" v-if="item.openBoxCode">
          <div class="cenname">开箱码：</div>
          <p>{{ item.openBoxCode }}</p>
        </div>
        <div class="ordercen font28 c999 mt20">
          <div class="cenname">停放位置：</div>
          <div>
            <span>{{ item.parkingPosition }}</span>
            &nbsp;&nbsp;&nbsp;
            <span style="color: #397AFA;" v-if="item.parkingPhoto[0]"
              @click="openThephoto(item.parkingPhoto[0])">查看照片</span>
          </div>
        </div>
        <div class="ordercen font28 c999 mt20" v-if="item.remarks">
          <div class="cenname">车主留言：</div>
          <p>{{ item.remarks }}</p>
        </div>

        <div class="evaluation mt20 c333 font28" v-if="item.comment">
          <div class="evaluationtitle">
            <span>车主评价</span>
            <span class="textcolor" v-if="item.score == 1" style="font-weight: bold;">好评</span>
            <span class="textcolor" v-if="item.score == 2" style="font-weight: bold;">中评</span>
            <span class="textcolor" v-if="item.score == 3" style="font-weight: bold;">差评</span>
          </div>
          <div class="c666 mt20">{{ item.comment }}</div>
          <div v-if="item.reply">
            <div class="jishireply mt20"> <img class="jishi" src="../../static/image/jishi.png" alt="">回复：</div>
            <div class="mt20">{{ item.reply }}</div>
          </div>
        </div>
        <div class="mt20">
          <div class="servicename c333 font28" v-for="orderInfo in item.orderInfo" v-bind:key="orderInfo.orderId">
            <span>{{ orderInfo.siName }}&nbsp;&nbsp;&nbsp;&nbsp;{{ orderInfo.siTimeConsuming }}min</span>
            <span>￥{{ orderInfo.siPrice }}</span>
          </div>
        </div>

        <div class="ordertitle vehicle pricelist font24 textcolor">
          <span>优惠金额：</span>
          <span>￥{{ item.discountAmount }}</span>
        </div>

        <div class="ordertitle vehicle pricelist font24 textcolor">
          <span>实付金额：</span>
          <span>￥{{ item.payAmount }}</span>
        </div>

        <div class="ordertitle vehicle pricelist font24 textcolor mb10">
          <span>本单收入：</span>
          <span>￥{{ item.income }}</span>
        </div>

        <!-- 自助设备 -->
        <div v-if="(item.step == 'WI' || item.step == 'SS') && !item.selfCarWash">
          <div class="equipment-li font26"
            :class="equipmentId == mentitem.equipmentId && item.orderId == selfHelpOrderId ? 'equipment-li-active' : ''"
            v-for="(mentitem, index) in item.selfCarWasheList" :key="index"
            @click="selectEquipment(mentitem, item.orderId)">
            <span class="c333 equipment-name fontbold">{{
              mentitem.equipmentName
              }}</span>
            <span class="c333" v-if="mentitem.status == '0'">正常</span>
            <span class="equipment-error" v-if="mentitem.status == '1'">维护中</span>
            <span class="equipment-error" v-if="mentitem.status == '2'">使用中</span>
          </div>
        </div>
        <!-- 已经启动的自助设备 -->
        <!-- selfCarWash -->
        <div class="equipment-li font26 equipment-li-active" v-if="item.selfCarWash">
          <span class="c333">正在使用</span>
          <span class="c333 equipment-name fontbold">{{ item.selfCarWash.equipmentName }}</span>
        </div>

        <!-- 按钮 -->
        <div class="btnlist mt20 font28" v-if="item.step == 'UP'">
          <!--  <div class="refuse cbf">拒绝</div> -->
          <div class="refuse benone receive  btncolor c333" @click="receiveOrder(item.orderId)">抢单</div>
        </div>
        <div class="btnlist mt20 font28 btnlist-big">
          <div class="refuse benone btncolor mb10 c333" @click="navToPictures(0, item.orderId)"
            v-if="item.step == 'WG'">
            取车外检</div>
          <div class="refuse benone btncolor mb10 c333" @click="workStart(item)" v-if="item.step == 'WI'">开始作业
          </div>
          <div class="kxlist" v-if="item.openBoxCode">
            <div class="refuse benonekx  mb10 c999">开箱码：{{ item.openBoxCode }}</div>
            <div class="refuse c333 enterys btncolor" @click="reloadPage()" v-if="item.step != 'RI'">完成取钥匙</div>
            <div class="refuse c333 enterys btncolor" @click="reloadPage()" v-if="item.step == 'RI'">完成放钥匙</div>
          </div>
          <div class="refuse benone btncolor mb10 c333" v-if="item.step == 'UG' && item.comment && item.reply == null"
            @click="showPopup(item.orderId)">评价回复</div>
          <div class="refuse benone btncolor mb10 c333" @click="navToComplete(item.orderId)"
            v-if="item.step == 'SS' && item.selfCarWasheList.length <= 0">作业完成
          </div>
          <div class="kxlist" v-if="item.step == 'SS' && item.selfCarWasheList.length > 0">
            <div class="refuse benonekx  mb10 c999" style="width: 35%;" @click="closeEquipment(item)"
              v-if="item.selfCarWash">关闭设备</div>
            <div class="refuse benonekx  mb10 c999" style="width: 35%;" v-else @click="openEquipment(item)">开启设备</div>
            <div class="refuse c333  btncolor" style="width: 60%;border: none;" @click="navToComplete(item.orderId)">
              作业完成</div>

          </div>

          <div class="refuse benone btncolor mb10 c333" @click="navToPictures(1, item.orderId)"
            v-if="item.step == 'ES'">
            还车外检</div>

        </div>
        <!-- 按钮end -->
      </li>
    </ul>

    <van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
      <div class="replytitle">
        <span class="c999 font28" @click="showPopup">取消</span>
        <div class="font28 cfff replytitlebtn btncolor" @click="publishedReply">发表</div>
      </div>
      <div class="textreply">
        <textarea name="" id="" placeholder="输入你的回复" v-model="reply" class="textarea c666 font26"></textarea>
      </div>
    </van-popup>

  </div>

</template>

<script>
import {
  ImagePreview,
  Toast
} from 'vant'

export default {
  data () {
    return {
      show: false,
      reply: '',
      orderId: '',
      busy: false,
      equipmentId: '', // 自助设备id
      selfHelpOrderId: '', // 当前操作的自助订单id
      equipmentName: '' // 自助设备名称
    }
  },
  created () {
    // 获取父组件的数据

  },
  mounted () {

  },
  props: ['orderInfo', 'total', 'formData', 'timeValue'],

  methods: {
    // 查看图片
    openThephoto (photo) {
      var url = photo // this.$api.host +   图片没有域名时候要加
      ImagePreview({
        // images:[`${this.$api.host}${photo}`],
        images: [url],
        showIndex: true,
        loop: true,
        closeOnPopstate: true,
        closeable: true
      })
    },
    /// ///////////////////////////////接单//////////////////////////////////////////////////////////
    receiveOrder (orderId) {
      var that = this
      Toast.loading({
        message: '接单中...',
        forbidClick: true,
        duration: 0
      })
      var data = {
        orderId: orderId
      }
      this.$api.HZrequest('/we-chat/gzh/receive-order', 'POST', data).then((res) => {
        if (res.data == true) {
          Toast('成功接单')
          setTimeout(function () {
            that.$router.push({
              path: '/service'
            })
          }, 500)
        } else {
          setTimeout(function () {
            Toast('抢单失败')
            setTimeout(function () {
              that.$parent.refreshInfo()
            }, 500)
          }, 500)
        }
      })
    },

    /// //////////////////////////开箱码 下一步//////////////////////
    // 下一步刷新页面重新请求
    reloadPage () {
      location.reload()
    },
    /// /////////////////////////////////取车外检///////////////////////////////////////////////////////
    // 跳转取车外检页面
    navToPictures (typeid, orderid) { // type 0取车 1还车
      this.$router.push({
        path: '/pictures',
        query: {
          type: typeid,
          orderId: orderid
        }
      })
    },
    /// ///////////////////////////开始作业//////////////////////////////////////////////
    workStart (row) {
      let that = this
      let data = {
        orderId: row.orderId
      }
      if (row.selfCarWasheList.length > 0 && (!this.equipmentId || this.selfHelpOrderId != row.orderId)) {
        Toast('请先选择设备')
        return
      }
      if (this.equipmentId) {
        data.equipmentId = this.equipmentId
      }

      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      this.$api.HZrequest('/we-chat/gzh/start-service', 'POST', data).then((res) => {
        if (res.code == 200) {
          // 开始服务
          for (let i = 0; i < that.orderInfo.length; i++) {
            if (that.orderInfo[i].orderId == row.orderId) {
              setTimeout(function () {
                // that.orderInfo[i].step.desc = '开始服务'
                that.orderInfo[i].step = 'SS'
                Toast('服务开始')
              }, 500)
            }
          }
        }
      })
    },

    /// /////////////////////////////////作业完成模块功能///////////////////////////////////////////////////////

    // 作业完成跳转到服务完成页
    navToComplete (orderId) {
      this.$router.push({
        path: '/complete',
        query: {
          orderId: orderId
        }
      })
    },
    /// /////////////////////////////////回复评价模块功能///////////////////////////////////////////////////////
    // var orderId={}
    // 评价回复弹出框
    showPopup (orderId) {
      this.show = !this.show
      this.orderId = orderId
    },
    // 回复成功
    publishedReply () {
      var that = this
      var value = this.reply.replace(/\s*/g, '') // 将输入的内容去掉空格
      var data = {
        orderId: this.orderId,
        washerReply: this.reply
      }
      if (value == '') {
        Toast('请输入回复内容')
        return
      }
      this.$api.HZrequest('/we-chat/gzh/washer-reply', 'POST', data).then((res) => {
        if (res.code == 200) {
          Toast('回复成功')
          for (let i = 0; i < that.orderInfo.length; i++) {
            if (that.orderInfo[i].orderId == that.orderId) {
              that.orderInfo[i].reply = that.reply
            }
          }
          that.showPopup()
        } else {
          Toast('提交失败，请重试')
        }
      })
    },
    loadMore: function () {
      if (this.total != '' && this.orderInfo.length < this.total) {
        this.formData.pageNum++
        if (this.timeValue) {
          this.$parent.getIndexInfo(this.timeValue, this.formData)
        } else {
          this.$parent.getIndexInfo(this.formData)
        }
      }
    },
    // 选择自助设备
    selectEquipment (equipment, orderId) {
      if (equipment.status != 0) {
        return
      }
      this.equipmentId = equipment.equipmentId
      this.selfHelpOrderId = orderId
      this.equipmentName = equipment.equipmentName
    },
    closeEquipment (row) {
      console.log(row)
      this.$api.HZrequest('/we-chat/gzh/close/equipment/id?orderId=' + row.orderId, 'POST', {}).then((res) => {
        if (res.code == 200) {
          Toast('关闭成功')
          // for (let i = 0; i < that.orderInfo.length; i++) {
          //   if (that.orderInfo[i].orderId == row.orderId) {
          //     that.orderInfo[i].selfCarWash = null
          //   }
          // }
          location.reload()
        } else {
          Toast('关闭失败，请重试')
          location.reload()
        }
      })
    },
    openEquipment (row) {
      let that = this
      if (!this.equipmentId || this.selfHelpOrderId != row.orderId) {
        Toast('请先选择设备')
        return
      }
      this.$api.HZrequest('/we-chat/gzh/open/equipment/id', 'POST', { orderId: row.orderId, equipmentId: that.equipmentId }).then((res) => {
        if (res.code == 200) {
          Toast('启动成功')
          // for (let i = 0; i < that.orderInfo.length; i++) {
          //   if (that.orderInfo[i].orderId == row.orderId) {
          //     that.orderInfo[i].selfCarWash.equipmentId = that.equipmentId
          //     that.orderInfo[i].selfCarWash.equipmentName = that.equipmentName
          //   }
          // }
          location.reload()
        } else {
          Toast('启动失败，请重试')
          location.reload()
        }
      })
    }

  }
}
</script>

<style>
body {
  padding-bottom: 1.2rem
}

.enterys {
  width: 35% !important;
  border: none !important;
}

.orderlist {
  width: 100%;
  height: 800px;
  box-sizing: border-box;
  padding: 0 0.32rem;
  overflow-y: auto;
}

.orderlist::-webkit-scrollbar {
  display: none;
  /* Chrome Safari */
}

.listli {
  width: 100%;
  background: #fff;
  box-sizing: border-box;
  padding: 0 0.24rem;
  padding-bottom: 0.26rem;
}

.ordertitle {
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid #eee;
  height: 0.92rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.vehicle {
  border: none
}

.ordercen {
  display: flex;
  width: 100%;
}

.cenname {
  width: 1.62rem;
}

.ordercen p {
  width: calc(100% - 1.62rem);
}

.servicename {
  width: 100%;
  height: 0.88rem;
  box-sizing: border-box;
  border: 1px solid #eee;
  border-left: none;
  border-right: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.pricelist {
  height: 0.6rem;
}

.btnlist {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.refuse {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border: 1px solid #bfbfbf;
  border-radius: 0.08rem;
  height: 0.68rem;
  width: 2rem;
}

.receive {
  width: 3.94rem;
  border: none;
}

.benone {
  width: 100%;
  border: none;
}

.benonekx {
  width: 60%;
  /* border: none; */
}

.btnlist-big {
  flex-wrap: wrap;
}

.replytitle {
  width: 100%;
  height: 0.95rem;
  box-sizing: border-box;
  border-bottom: 1px solid #E5E5E5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 .32rem;
}

.replytitlebtn {
  width: 0.98rem;
  height: 0.54rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.28rem;
}

.textreply {
  width: 100%;
  height: calc(100% - 0.95rem);
}

.textarea {
  display: block;
  width: 100% !important;
  height: 100% !important;
  box-sizing: border-box;
  padding: 0.32rem;
  resize: none;
}

.evaluation {
  width: 100%;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 0.08rem;
  padding: 0.14rem;
}

.evaluationtitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.jishi {
  width: 0.4rem;
  margin-top: -0.06rem;
}

.jishireply {
  display: flex;
  align-items: center;
}

.kxlist {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.self-help-button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.equipment-li {
  width: 100%;
  height: 0.8rem;
  background: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  border-radius: 0.1rem;
  margin-top: 0.1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 0.2rem;
}

.equipment-li-active {
  background: #fec908;
}

.equipment-error {
  color: #f00;
}
</style>



// WEBPACK FOOTER //
// src/components/orderlist.vue